import React, { Component } from 'react'
import { GetData } from '../../api/service';
import GrievanceTable from './GrievanceTable';

export default class GrievanceContent extends Component {

    state = {
        table_data: [],
        isLoading: true
    }

    componentDidMount() {
      this.loadData();
    }

    loadData = () => {
        GetData(`/${this.props.apikey}/${this.props.username}/getgreivance`)
      .then((resp) => {
          //console.log(resp);
          this.setState({
              table_data: resp,
              isLoading: false
          })
      })
    }
    
    render() {

        return (
            <div>

                {!this.state.isLoading ?
                    <GrievanceTable
                        table_data={this.state.table_data}
                        isLoading={this.state.isLoading}
                        history={this.props.history}
                        reload={this.loadData}
                    />
                    : null}

            </div>
        )
    }
}
